import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Button = ({
  className: classNameProp,
  component: Component,
  variant,
  dataTestId,
  kind,
  ...other
}) => {
  const className = classNames(
    'button',
    {
      [`button-${variant}`]: variant,
      [`button-kind-${kind}`]: kind,
    },
    classNameProp
  )
  return <Component className={className} data-testid={dataTestId} dataTestId={dataTestId} {...other} />
}

Button.propTypes = {
  className: PropTypes.string,
  kind: PropTypes.oneOf(['small', 'medium', 'large']),
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
  ]),
  dataTestId: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'secondary', 'solid', 'orange', 'link', 'info', 'notification']),
}

Button.defaultProps = {
  component: 'a',
  kind: 'large',
  variant: 'default',
}

export default Button
